export default `
  mutation updateProject($id: String!, $organisationId: String!, $name: String!) {
    updateProject(id: $id, organisationId: $organisationId, name: $name) {
      id
      name
      organisationId
      organisation {
        id
        name
        userId
        user {
          id
          firstname
          lastname
        }
      }
      jiraForgeData {
        projectId
      }
    }
  }
`
